import React, { useEffect } from 'react';
import {
    Box,
    Tabs,
    TabList,
    TabPanels,
    Tab,
    TabPanel,

    Text,
    Center,
    Spinner,

} from '@chakra-ui/react';

import Prism from 'prismjs';
import 'prismjs/themes/prism-tomorrow.css';
import 'prismjs/components/prism-json';
import BoxWrapper from '../../components/BoxWrapper/BoxWrapper';
import Header from '../../components/Header';
import usePagePermissions from '../../hooks/usePagePermissions';
import { WebsiteTrackingCode } from './WebsiteTrackingCode';
import { MobileSDK } from './MobileSDK';
import { CustomEventAPI } from './CustomEventAPI';
import { MessageTracking } from './MessageTracking';

const EventDocumentation = () => {
    const { loading: permissionsLoading, can } = usePagePermissions('documentation/evt-docs');

    const eventDocPermission = can("event-doc");
    const eventPropertyCreatePermission = can("event-property-create");

    useEffect(() => {
        Prism.highlightAll();
    }, []);

    if (permissionsLoading) {
        return (
            <>
                <Header />
                <BoxWrapper>
                    <Center h="400px">
                        <Spinner size="xl" color="blue.500" thickness="4px" />
                    </Center>
                </BoxWrapper>
            </>
        );
    }

    return (
        <>
            <Header />
            {eventDocPermission ? (
            <BoxWrapper>
                {/* Header Section */}
                <Box style={{ width: '70%' }} mx="auto" borderBottom="1px" borderColor="#EAEAEA" bg="white">
                    <Box maxW="1100px" mx="auto" px={6} py={8}>
                        <Text fontSize={"4xl"} fontWeight={"semibold"}>
                            Event Tracking
                        </Text>
                        <Text color="gray.600" maxW="4xl" fontSize="md">
                            Track events from multiple sources including messages, web, mobile, and custom integrations
                        </Text>
                    </Box>
                </Box>

                {/* Tabs Section */}
                <Box style={{ width: '70%' }} mx="auto" px={6} pt={6}>
                    <Tabs colorScheme="blue" variant="enclosed" isLazy>
                        <TabList
                            bg="#f1f5f9"
                            p="1"
                            borderRadius="full"
                            display="flex"
                            justifyContent="space-between"
                        >
                            <Tab
                                flex="1"
                                _selected={{ bg: "white", boxShadow: "sm", fontWeight: "600" }}
                                borderRadius="full"
                                fontSize="sm"
                            >

                                Custom Event Ingestion API
                            </Tab>
                            <Tab
                                flex="1"
                                _selected={{ bg: "white", boxShadow: "sm", fontWeight: "600" }}
                                borderRadius="full"
                                fontSize="sm"
                            >

                                Website Tracking Code
                            </Tab>
                            <Tab
                                flex="1"
                                _selected={{ bg: "white", boxShadow: "sm", fontWeight: "600" }}
                                borderRadius="full"
                                fontSize="sm"
                            >

                                Mobile App SDK
                            </Tab>
                            
                            <Tab
                                flex="1"
                                _selected={{ bg: "white", boxShadow: "sm", fontWeight: "600" }}
                                borderRadius="full"
                                fontSize="sm"
                            >

                                From Message
                            </Tab>
                        </TabList>

                        <TabPanels>
                            <TabPanel p={0} pb={10}>
                                <CustomEventAPI />
                            </TabPanel>
                            <TabPanel p={0} pb={10}>
                                <WebsiteTrackingCode canCreateProperty={eventPropertyCreatePermission} />
                            </TabPanel>
                            <TabPanel p={0} pb={10}>
                                <MobileSDK />
                            </TabPanel>
                            
                            <TabPanel p={0} pb={10}>
                                <MessageTracking />
                            </TabPanel>
                        </TabPanels>
                    </Tabs>
                </Box>
            </BoxWrapper>
            ) : (
                <Center h="400px">
                    <Box textAlign="center">
                        <Text fontSize="xl" fontWeight="semibold" color="gray.700" mb={2}>
                            No Access
                        </Text>
                        <Text fontSize="sm" color="gray.500">
                            You don't have permission to view this sections.
                        </Text>
                    </Box>
                </Center>
            )}
        </>
    );
};






export default EventDocumentation;